import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-blog-versioning',
  templateUrl: './blog-versioning.component.html',
  styleUrls: ['./blog-versioning.component.scss']
})
export class BlogVersioningComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
